import { Field as FinalField } from 'react-final-form';
import { FieldProps } from './Field.types';

export function Field<FieldValue = any, T extends HTMLElement = HTMLElement>(
  props: FieldProps<FieldValue, T>,
): JSX.Element {
  if (typeof props.children === 'function') {
    const { children, label, name } = props;

    return (
      <FinalField {...props}>
        {fieldProps => {
          // inject label and id props
          const hasError = fieldProps.meta && fieldProps.meta.error;
          const inputProps = {
            className: hasError ? '-error' : '',
            ...fieldProps.input,
            id: name,
            label,
          };

          inputProps['data-testid'] = name;
          return (children as any)({ ...fieldProps, input: inputProps });
        }}
      </FinalField>
    );
  } else {
    return <FinalField {...props} />;
  }
}
